









import VueOptions from '@utils/VueOptions'
import VenueInPersonForm from '@ui/AudienceSetWizard/VenueStep/forms/VenueInPersonForm'

settings =
  name: 'VenueOngoingForm'

  vue:
    props: ['wizard', 'venue']

    components: {
      VenueInPersonForm,
    }

export default VueOptions.vue settings
